export const contentTableConfig = {
  title: '权限列表',
  propList: [
    { prop: 'name', label: '权限名', minWidth: '100', align: 'left' },
    { prop: 'value', label: '权限值', minWidth: '80' },
    { prop: 'icon', label: '图标', minWidth: '80', slotName: 'icon' },
    { prop: 'uri', label: '资源路径', minWidth: '100' },
    { prop: 'status', label: '状态', minWidth: '60', slotName: 'status' },
    { prop: 'sort', label: '排序', minWidth: '60' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      slotName: 'createdTime'
    },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '120',
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  childrenProps: {
    rowKey: 'id',
    treeProps: {
      children: 'permissions'
    }
  },
  showFooter: false
}
